import {AfterContentChecked, AfterContentInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {AbstractSigaleComponent} from '../../abstract-sigale.component';

@Component({
	standalone: true,
	selector: 'footerBar',
	templateUrl: './footerBar.component.html',
	styleUrls: ['./footerBar-bar.component.scss']
})
export class FooterBarComponent extends AbstractSigaleComponent implements AfterContentInit, AfterContentChecked {

	@ViewChild('container', {static: true}) containerDiv: ElementRef;

	constructor() {
		super();
	}

	ngAfterContentInit(): void {
		this.addClassToButtons();
	}

	ngAfterContentChecked(): void {
		this.addClassToButtons();
	}

	/**
	 * Ajoute les classes aux buttons ce trouvant dans le ng-content s'il en manque
	 * @private
	 */
	private addClassToButtons() {
		this.getButtons().forEach(button => {
			if (!button.classList.contains('btn')) {
				button.classList.add('btn')
			}
			if (!button.classList.contains('btn-primary')) {
				button.classList.add('btn-primary')
			}
			if (!button.classList.contains('mx-2')) {
				button.classList.add('mx-2')
			}
			if (!button.classList.contains('my-1')) {
				button.classList.add('my-1')
			}
			if (!button.classList.contains('py-1')) {
				button.classList.add('py-1')
			}
			if (!button.classList.contains('rounded-0')) {
				button.classList.add('rounded-0')
			}
		});
	}

	/**
	 * Récupère les éléments HTML <button>
	 */
	getButtons(): HTMLButtonElement[] {
		return this.containerDiv.nativeElement.querySelectorAll("button");
	}
}
